import {sessionStore} from "./sessionStore";

function getMember() {
    return sessionStore.get("member");
}

export function setOrganization(values) {
    const member = getMember();

    if (member) {
        values.organization = `/organizations/${member["organization"]}`;
    }
}

export function setMember(values) {
    const member = getMember();

    if (member) {
        values.member = `/members/${member["id"]}`;
    }
}

export function getCurrentOrganizationId() {
    const member = getMember();

    if (!member) {
        return null;
    }

    return member["organization"];

}

export function setEshopConfig(values) {
    const member = getMember();

    if (member) {
        values.eshopConfig = `/eshop_configs/${member["eshopConfig"]}`;
    }
}
